import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { useUserTracker } from '@termly-web/common'

import { useAuth } from 'pkg/authentication'

import useBillingInfoQuery from 'hooks/useBillingInfoQuery'


export default function UserTrackerLogin({ children }) {
  const userTracker = useUserTracker()

  const { user } = useAuth()

  const {
    billingInfo,
    isInitialLoading: isLoading,
  } = useBillingInfoQuery({
    enabled: !user.guest,
  })

  // Note that the server dictates no caching of the billing info
  // query, so the `billingInfo` object will be a brand new object for
  // every invocation of `useBillingInfoQuery()`. This means that if
  // we use `billingInfo` as the dependency for the `useEffect()`
  // hook, below, we'll wind up invoking the effect regardless of
  // whether or the record has a website. This is bad, because it
  // causes some user tracker clients to re-initialize and lose state
  // (i.e., it'll kick the curren user out of his session).
  const hasWebsite = Boolean(billingInfo.used_license_count)

  useEffect(() => {
    if ( isLoading ) {
      return
    }

    userTracker.signIn({
      hasWebsite,
      user,
    })
  }, [hasWebsite, isLoading, user, userTracker])

  return children
}

UserTrackerLogin.propTypes = {
  children: PropTypes.node,
}
